<div class="container">
  <div class="container__title">
    <h1
      class="title"
      [innerHTML]="book.caption"
    ></h1>
  </div>
  <div class="container__info">
    <div class="info">
      <div class="info__gallery">
        <lib-gallery [photos]="book.photos"></lib-gallery>
      </div>
      <div class="info__description">
        <div class="description">
          <div class="description__section">
            <lib-notice
              [alias]="book.alias"
              [caption]="book.notice.caption"
              [description]="book.notice.description"
              [points]="book.notice.points"
              [prices]="book.prices"
              [vaguePrice]="true"
              [discount]="discountService.getDiscount$(book.alias) | async"
              buttonText="ギフトコード対応"
              (buttonClick)="onNoticeButtonClick()"
            ></lib-notice>
          </div>
          <div
            *ngIf="media.isActive('gt-lg') && book.review as review"
            class="description__section reviews"
          >
            <section class="reviews">
              <div class="reviews__content">
                <p
                  *ngFor="let text of review.text"
                  class="reviews-text"
                >
                  {{ text }}
                </p>
              </div>
              <footer class="reviews__footer">
                <a
                  href="#reviews"
                  class="reviews-text"
                  >レビューを読む</a
                >
                <img
                  src="assets/images/reviews-stars.png"
                  alt="★★★★★"
                  class="reviews-stars"
                />
              </footer>
            </section>
          </div>
          <div
            *ngIf="media.isActive('gt-lg') && book.points?.length"
            class="description__section"
          >
            <lib-points [points]="$any(book.points)"></lib-points>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container__form">
    <lib-book-form
      class="form"
      [alias]="book.alias"
      [inputs]="book.inputs"
      (submitted)="submitted($event)"
      [getErrorText]="getErrorText"
    ></lib-book-form>
  </div>
  <div class="container__date">
    <lib-section-message-date></lib-section-message-date>
  </div>
  <div
    *ngIf="!media.isActive('gt-lg') && book.review as review"
    class="container__book-reviews"
  >
    <section class="reviews">
      <div class="reviews__content">
        <p
          *ngFor="let text of review.text"
          class="reviews-text"
        >
          {{ text }}
        </p>
      </div>
      <footer class="reviews__footer">
        <a
          href="#reviews"
          class="reviews-text"
          >レビューを読む</a
        >
        <img
          src="assets/images/reviews-stars.png"
          alt="★★★★★"
          class="reviews-stars"
        />
      </footer>
    </section>
  </div>
  <div
    *ngIf="media.isActive('lt-xl') && book.points?.length"
    class="container__points"
  >
    <lib-points [points]="$any(book.points)"></lib-points>
  </div>
  <div
    *ngIf="reviewsData"
    class="container__pictures-reviews"
  >
    <lib-section-reviews
      *ngIf="book.alias !== 'froebelkan-mainichi-kinenbi'"
      imageTitleSrc="assets/images/title-reviews-2.png"
      imageTitleText="モニターの皆様からのご感想"
      [reviews]="
        book.alias === 'froebelkan'
          ? reviewsDataFKBook1
          : book.alias === 'froebelkan-alphabet-train'
            ? reviewsDataFKBook2
            : []
      "
      [showMonster]="false"
    >
      <div style="text-align: center; margin-top: 20px">
        <a
          class="review-link"
          routerLink="/reviews"
          >すべてのレビューを読む</a
        >
      </div>
    </lib-section-reviews>
  </div>
  <div class="container__steps">
    <lib-section-steps [steps]="stepsData"></lib-section-steps>
  </div>
  <div
    *ngIf="descriptionData"
    class="container__description"
  >
    <lib-description [description]="descriptionData"></lib-description>
  </div>
  <div
    id="reviews"
    class="container__reviews"
  >
    <lib-section-reviews-yotpo-v3-book
      [alias]="book.alias"
      [caption]="book.caption"
      [price]="book.prices[0]?.[1]?.value!"
      [photo]="book.previewPhoto"
      title="リアルタイムレビュー"
      instanceId="1020425"
      [showMonster]="false"
    ></lib-section-reviews-yotpo-v3-book>
  </div>
  <div class="container__footer-banner">
    <app-section-footer-banner
      [isBK1]="book.alias === 'froebelkan'"
      [isBK2]="book.alias === 'froebelkan-alphabet-train'"
      [isBK3]="book.alias === 'froebelkan-mainichi-kinenbi'"
    ></app-section-footer-banner>
  </div>
  <div class="container__faq">
    <lib-section-faq
      [faqData]="faqDataCondensed"
      (buttonClick)="onFaqButtonClick()"
      [condensed]="true"
    ></lib-section-faq>
  </div>
  <div class="container__section-footer-banners">
    <app-section-footer-banners></app-section-footer-banners>
    <br /><br />
    <p *ngIf="book.alias === 'froebelkan'">©やなせたかし</p>
    <p *ngIf="book.alias === 'froebelkan-alphabet-train'">©ISHIKAWA Hyuga</p>
    <p *ngIf="book.alias === 'froebelkan-mainichi-kinenbi'">©minna</p>
  </div>
</div>
